<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="a-marriage-made-in-heaven">
<h1>A Marriage Made in Heaven</h1>
<p style="text-indent:0em">You said you would always love me,</p>
<p style="text-align:right"><img alt="" src="media/file0.png" style="width:2.10556in;height:1.59167in; float:right; transform:rotate(270deg);filter:grayscale(100%)"/></p>
<p style="text-indent:0em">you said you would always care.</p>
<p style="text-indent:0em">When you left me, my heart was torn in two,</p>
<p style="text-indent:0em">just thinking about you.</p><br/>
<p style="text-indent:0em">Now who will remember my birthday?</p>
<p style="text-indent:0em">Who will kiss me goodnight?</p>
<p style="text-indent:0em">And when I sometimes falter,</p>
<p style="text-indent:0em">You were always there, to show me the light.</p><br/>
<p style="text-indent:0em">I lie awake in bed each night,</p>
<p style="text-indent:0em">waiting for the morning air.</p>
<p style="text-indent:0em">My days are long and lonely,</p>
<p style="text-indent:0em">I hide from my despair.</p><br/>
<p style="text-indent:0em">One day we’ll be together again,</p>
<p style="text-indent:0em">and when that day comes, our hearts will be one.</p>
<p style="text-indent:0em">The months go by and yet, I still feel the anger there as,</p>
<p style="text-indent:0em">I am here, and she is there.</p><br/>
<p style="text-indent:0em">One day we’ll be together again,</p>
<p style="text-indent:0em">Hand in hand with God, once again.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?4538fd78